import { FaMoon, FaSun } from 'react-icons/fa';
import useDarkSide from '../../hooks/main/display-mode-switcher';

export default function Switcher() {
  const [theme, setTheme] = useDarkSide();

  const toggleDarkMode = () => {
    setTheme(prevTheme => (prevTheme === 'dark' ? 'light' : 'dark'));
  };

  return (
    <div
      onClick={toggleDarkMode}
      className={`
        flex items-center justify-between w-14 h-8 p-1 rounded-full 
        cursor-pointer border shadow-inner transition-colors duration-300
        ${theme === 'dark' ? 'bg-gray-800 border-gray-700' : 'bg-yellow-300 border-yellow-400'}
      `}
    >
      <div
        className={`
          flex items-center justify-center w-6 h-6 rounded-full bg-white shadow-md transform transition-transform duration-300
          ${
            theme === 'dark'
              ? 'translate-x-0' 
              : 'translate-x-5'
          }
        `}
      >
        {theme === 'dark' ? (
          <FaMoon className="text-gray-800 text-xs" />
        ) : (
          <FaSun className="text-yellow-400 text-xs" />
        )}
      </div>
    </div>
  );
}
